module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ('background-image:url(' + _vm.imgPath + 'luckdraw/bg3.png)'),
    attrs: {
      "id": "prizes"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.imgPath + 'luckdraw/person.png'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "prize-win-panel"
  }, [_c('div', {
    staticClass: "tbbox"
  }, [(_vm.prizelist) ? _c('table', {
    staticClass: "prize-win-list"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.prizelist), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.exchange_code))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.create_time.split(' ')[1]))])])
  }), 0)]) : _c('p', {
    staticClass: "center"
  }, [_c('br'), _vm._v("暂无中奖信息")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "main-top",
    attrs: {
      "src": _vm.imgPath + 'luckdraw/main-top.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "way"
  }, [_c('h3', [_vm._v("兑奖方式")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.imgPath + 'luckdraw/manner_border.png'
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.prizeRemark))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("奖品")]), _vm._v(" "), _c('th', [_vm._v("兑奖码")]), _vm._v(" "), _c('th', [_vm._v("时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16c6edc6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/prizes.vue
// module id = 260
// module chunks = 0